import useLanguage from "../i18n/useLanguage";

export default function LanguageSwitcher() {
  const { language, setLanguage, t } = useLanguage();
  return (
    <div role="group" aria-label={t("Language")} className="inline-flex shrink-0 rounded-full border border-white/20 bg-black/60 p-1">
      {["id", "en"].map(value => (
        <button key={value} type="button" lang={value} aria-label={value === "id" ? "Bahasa Indonesia" : "English"} aria-pressed={language === value} onClick={() => setLanguage(value)} className={`rounded-full px-3 py-1.5 text-xs font-bold transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-amber-300 ${language === value ? "bg-amber-300 text-black" : "text-gray-300 hover:text-white"}`}>
          {value.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
